var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookKnowledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 3.5763V10.9582L3.8 10.1729V3.62931C3.8 3.24058 4.13375 2.94413 4.49938 3.00892L7.7 3.5763ZM3.68188 10.9013L8 11.8063L12.3181 10.9013C12.5994 10.8424 12.8 10.5852 12.8 10.2848V3.51152L13.2819 3.41139C13.6531 3.33482 14 3.63128 14 4.02786V11.2272C14 11.5275 13.7975 11.7847 13.5181 11.8436L8 13L2.48188 11.8436C2.2025 11.7867 2 11.5275 2 11.2291V4.02786C2 3.63128 2.34688 3.33482 2.71813 3.41335L3.2 3.51348V10.2868C3.2 10.5871 3.4025 10.8443 3.68188 10.9032V10.9013ZM8.3 10.9582V3.5763L11.5006 3.00892C11.8663 2.94413 12.2 3.24058 12.2 3.62931V10.1729L8.3 10.9582Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookKnowledge);
export default __webpack_public_path__ + "static/media/book-knowledge.b858e66cf9bda3dd4db54c11da557139.svg";
export { ForwardRef as ReactComponent };